/**
 * Mobile behaviors for search facets
 * No dependencies
 */

// Facets mobile control
const openButtons = document.getElementsByClassName('js-mobile-facets-open');
const closeButtons = document.getElementsByClassName('js-mobile-facets-close');
for (let index = 0; index < openButtons.length; index++) {
  const openBtn = openButtons[index];
  openBtn.addEventListener('click', () => {
    document.body.classList.add('facets-open');
  });
}
for (let index = 0; index < closeButtons.length; index++) {
  const closeBtn = closeButtons[index];
  closeBtn.addEventListener('click', () => {
    document.body.classList.remove('facets-open');
  });
}
